import * as React from 'react';

import * as main from '../../../styles/mainOld.module.scss';
import * as courseModule from './courseModule.module.scss';

export const CourseModuleTwo = ({ badgeText, resultText }) => {
  return (
    <section className={`${courseModule.courseModule} ${courseModule.courseModuleGrey}`}>
      <div className="container">
        <p className={courseModule.courseModule__important}>{badgeText} 2</p>
        <h3 className={courseModule.courseModule__subtitle}>
          Технологии ускоренного обучения и&nbsp;работы с&nbsp;большими объемами информации
        </h3>
        <p className={courseModule.courseModule__description}>
          Ребенок научится понимать причинно-следственные связи, как составной элемент сложных информационных объектов,
          что является не&nbsp;только ключом к&nbsp;пониманию и&nbsp;логическому мышлению, но основой гениальности, ведь
          именно целостное понимание проблемы позволяет находить решения из&nbsp;самых разных областей.
        </p>
        <div className={`row ${courseModule.courseModule__row}`}>
          <div className="col-12 col-lg-9">
            <p className={courseModule.courseModule__listTitle}>Формируемые навыки:</p>
            <ul className={courseModule.courseModule__list}>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Формировать сложные представления</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Находить определения и&nbsp;понимать термины</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>
                  Классифицировать объекты и&nbsp;находить критерии для этого
                </p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>
                  Понимать причинно-следственные связи через работу с&nbsp;дефинициями
                </p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Запоминать схемы, карты, планы</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Понимать смысл алгоритмов и&nbsp;формул</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Видеть логические связи</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Встраивать новую информацию в&nbsp;общую картину</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Переводить данные из&nbsp;слов в&nbsp;символы</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Структурировать разрозненную информацию</p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>
                  Самостоятельно оценивать результат интеллектуального труда
                </p>
              </li>
              <li className={`${courseModule.courseModule__item} ${courseModule.courseModule__itemBorder}`}>
                <p className={courseModule.courseModule__text}>Увеличить скорость переключения внимания</p>
              </li>
              <li className={courseModule.courseModule__item}>
                <p className={courseModule.courseModule__text}>Самостоятельно работать со&nbsp;школьным материалом</p>
              </li>
            </ul>
          </div>
          <div className={`col-12 col-lg-3 ${courseModule.courseModule__sideData}`}>
            <div className={main.sideData}>
              <p className={main.sideData__bigText}>
                <span className={main.sideData__bigTextAccent}>2–4</span>
              </p>
              <p className={main.sideData__smallText}>
                Ребенок начинает учиться в&nbsp;2&nbsp;–&nbsp;4&nbsp;раза быстрее
              </p>
            </div>
            <div className={main.sideData}>
              <p className={main.sideData__bigText}>
                <span className={main.sideData__bigTextAccent}>4–5</span>
              </p>
              <p className={main.sideData__smallText}>
                дней достаточно для полного прохождения любого учебника самостоятельно
              </p>
            </div>
          </div>
        </div>

        <div className={courseModule.courseModule__result}>
          <h3 className={courseModule.courseModule__resultTitle}>{resultText}</h3>
          <div className="row">
            <div className={`col-12 col-md-12 col-lg-4 ${courseModule.courseModule__resultCol}`}>
              <p className={courseModule.courseModule__resultText}>
                Становится самостоятельным в&nbsp;учебе и&nbsp;сам делает домашние задания
              </p>
            </div>
            <div className={`col-12 col-md-12 col-lg-4 ${courseModule.courseModule__resultCol}`}>
              <p className={courseModule.courseModule__resultText}>
                Учится быстрее, есть время на&nbsp;спорт, развитие и&nbsp;увлечения
              </p>
            </div>
            <div className={`col-12 col-md-12 col-lg-4 ${courseModule.courseModule__resultCol}`}>
              <p className={courseModule.courseModule__resultText}>С удовольствием стремится к&nbsp;новым знаниям</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
